import { Injectable } from '@angular/core';
import { ApiEndpointService } from 'app/core/services/api-endpoint.service';
import { EnvironmentService } from 'app/core/services/environment.service';
import { HttpClientService } from 'app/core/services/http/http-client.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';

@Injectable()
export class SingleSignOnService {

    public constructor(private httpClientService: HttpClientService,
                       private apiEndpointService: ApiEndpointService,
                       private readonly environmentService: EnvironmentService,
    ) {

    }

    /**
     * Generate Zendesk SSO Token.
     *
     * @returns {Observable<any>}
     */
    public generateSSOToken(): Observable<any> {
        let endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.endpointUrls.generateSingleSignOn)
            .toString();

        if (!environment.feature.coreAuth) {
            const envAlias = this.environmentService.getEnvironmentAlias();
            const url = `https://${ envAlias ? `auth-${ envAlias }` : 'auth' }.parcelpro.com/api/SSO/Validate`;
            endpoint = SafeUrlAssembler().template(url).toString();
        }

        return this.httpClientService.get<any>(endpoint);
    }

}
